// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 695) return "695.6c4fb763871ac2998162.css";
	if (chunkId === 716) return "canvas.85b71c39dd7cb70c1000.css";
	// return url for filenames based on template
	return undefined;
};